import script from "./PhysicalPeople.vue?vue&type=script&setup=true&lang=js"
export * from "./PhysicalPeople.vue?vue&type=script&setup=true&lang=js"

import "./PhysicalPeople.vue?vue&type=style&index=0&id=4d72811e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d72811e"]])

export default __exports__